import React from 'react';

import { useLanguage } from '../Contexts/LanguageContext';

const TranslatedText = ({item}) => {
    const { language } = useLanguage();

    const getValue = () => {
        const translation = item?.translations?.find((item) => item.locale === language) ?? { locale: language, value: '' };
        return translation?.value ?? '';
    }

    return (
        <>{getValue()}</>
    );
}

export default TranslatedText;